import { X } from 'lucide-react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const badgeAnimation = {
  initial: { opacity: 0, scale: 0.95 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1] // Tailwind's default ease-out
    }
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.15,
      ease: [0.4, 0, 1, 1] // A sharper ease-out for exit
    }
  }
};

interface FilterChipProps {
  label: string;
  onRemove: () => void;
  className?: string;
}

export function FilterChip({ label, onRemove, className }: FilterChipProps) {
  return (
    <motion.div
      layout
      {...badgeAnimation}
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-md',
        'bg-accent/[0.04] border border-border/40',
        'text-sm text-foreground/70',
        className
      )}
    >
      <span className="truncate">{label}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className="rounded-sm -mr-0.5 p-0.5 hover:bg-accent/20 transition-colors"
      >
        <X className="h-3 w-3 text-foreground/50" />
      </button>
    </motion.div>
  );
}
